import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'user-button2',
  templateUrl: './user-button2.component.html',
  styleUrls: ['./user-button2.component.css']
})
export class UserButton2Component {
  @Input() size?: "sm" | undefined;
  @Input("is-loading") isLoading = false;
  @Input("has-error") hasError: boolean;
}
